import clsx from "clsx";
import { useMeetingContainerContext } from "../../contexts/meetingContainer/context";
import { MediaSourcePicker } from "./MediaSourcePicker"
import { useAppStoreSelector } from "../../contexts/appStore/selectors";

import styles from "./SourcePickerAlwaysOpen.module.css"
import { MeetingSourceExtended } from "../../hooks/meeting";
import React from "react";

export const SourcePickerAlwaysOpen = React.memo(({
  sources,
}: {
  sources: MeetingSourceExtended[];
}) => {
  const { containerAPI } = useMeetingContainerContext();
  const sourcePickerOpen = useAppStoreSelector(state => state.sourcePickerOpen);
  return (
    <MediaSourcePicker
      meetingAPI={containerAPI}
      sources={sources} // all sources together, cameras and screens
      display
      className={clsx({
        [styles.mediaSourcePicker]: true,
        [styles.invisible]: !sourcePickerOpen,
      })}
    />
  );
});